import { useLocation, useNavigate } from 'react-router-dom'
import { Compass, ArrowLeft, Home } from 'lucide-react'
import { isMobileDevice } from '../utils/deviceDetect'

/**
 * 없는 주소로 들어왔을 때 보여 주는 화면.
 *
 * ⚠ 이게 없으면 **아무것도 그려지지 않는다.** 라우트에 없는 경로는 React Router 가
 *   조용히 빈 화면을 내놓기 때문에, 메뉴 링크 하나가 오타이거나 페이지가 빠져 있으면
 *   사용자는 "눌러도 아무 일이 없다" 로만 겪게 된다 (2026-11-05 감사에서 14곳 확인).
 *   주소를 함께 보여 주는 이유도 같다 — 그래야 어디가 끊겼는지 바로 전달할 수 있다.
 */
export default function NotFound() {
  const location = useLocation()
  const navigate = useNavigate()
  const mobile = isMobileDevice()
  const home = mobile ? '/mobile/home' : '/'

  return (
    <div className="flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
          <Compass className="text-gray-400" size={30} />
        </div>

        <h1 className="text-lg font-semibold text-gray-900">페이지를 찾을 수 없습니다</h1>
        <p className="mt-2 text-sm leading-relaxed text-gray-500">
          주소가 바뀌었거나 아직 없는 화면입니다.
          <br />
          메뉴에서 다시 들어가 주세요.
        </p>

        <p className="mt-4 break-all rounded-md bg-gray-50 px-3 py-2 font-mono text-xs text-gray-400">
          {location.pathname}
        </p>

        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex min-h-[44px] items-center justify-center gap-1.5 rounded-lg border border-gray-300 px-4 text-sm text-gray-700 hover:bg-gray-50"
          >
            <ArrowLeft size={16} /> 뒤로 가기
          </button>
          <button
            type="button"
            onClick={() => navigate(home, { replace: true })}
            className="inline-flex min-h-[44px] items-center justify-center gap-1.5 rounded-lg bg-blue-600 px-4 text-sm font-medium text-white hover:bg-blue-700"
          >
            <Home size={16} /> 홈으로
          </button>
        </div>
      </div>
    </div>
  )
}
